import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertCurrency'
})
export class ConvertCurrencyPipe implements PipeTransform {

  transform(price: any): any {
    price = Math.round(price * 100) / 100;
    if (price >= 100000 && price < 10000000) {
        price = price / 100000;
        price = Math.round(price * 100) / 100
        return "<span class='af-price'> "+price+" </span>" + "<span class='af-scale'> Lac</span>";
    } else if(price >= 10000000) {
        price = price / 10000000;
        price = Math.round(price * 100) / 100
        return "<span class='af-price'> "+price+" </span>" + "<span class='af-scale'> Crore </span>";
    }
    return price;
  }

}
